import { render, staticRenderFns } from "./SavedPlanSummary.vue?vue&type=template&id=1b37fd42&"
import script from "./SavedPlanSummary.vue?vue&type=script&lang=js&"
export * from "./SavedPlanSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports